<template>
  <div id="fourOfour-container" class="text-center d-flex align-items-center justify-content-center flex-column">
    <img src="@/assets/images/404.svg" alt="404" class="img-fluid mb-2">
    <h3 class="text-muted" v-if="errors"> {{ errors.errors.message }} </h3>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      errors: "estore/errors"
    })
  }
};
</script>

<style lang="scss" scoped>
#fourOfour-container {
  height: 100vh;
}
</style>
